// extracted by mini-css-extract-plugin
export default {"cross_history":"YBeQ6uQowsZV1LEl2Dw7P","cross_history_item":"_3Wu080cBvzQvsBbpGukd80","cross_history_header":"kDQURn9A5NPFrtydh24iI"};